import service from '@/utils/request'

export interface AppVersionConfig {
  id?: number
  platform: string
  min_version: string
  latest_version: string
  update_url: string
  update_message: string
  is_enabled: boolean
  created_at?: string
  updated_at?: string
}

/** 获取所有平台的版本配置 */
export async function getAppVersions(): Promise<AppVersionConfig[]> {
  const response = await service.get('/api/app_config/versions')
  return response.data?.data || []
}

/** 创建或更新版本配置 */
export async function upsertAppVersion(data: Partial<AppVersionConfig>): Promise<AppVersionConfig> {
  const response = await service.post('/api/app_config/versions', data)
  return response.data?.data
}
